module.exports = __webpack_public_path__ + "static/Highlight3-86afb2a80d50604438673d3435a1ced5.png";